import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import Script from "next/script";
import B2BLayout from "../B2BLayout/B2BLayout.esm.js";
import AgentLoginModal from "../AgentLoginModal/AgentLoginModal.esm.js";
import ZillowForAgentsLogo from "./assets/zillow-pro.svg.esm.js";
import { HEADER_CTAS, FOOTER_COLUMNS, LAYOUT_MENU_ITEMS } from "./constants/layout.esm.js";
const ZillowForAgentsLayout = ({
  children,
  submenu,
  header,
  router,
  environment,
  knotchAccountId
}) => {
  const img = {
    src: ZillowForAgentsLogo,
    alt: "Zillow for Agents",
    width: 215,
    height: 25,
    blurHeight: 0,
    blurWidth: 0,
    link: "/pro/"
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    !!knotchAccountId && /* @__PURE__ */ jsx(Script, { src: `https://www.knotch-cdn.com/ktag/latest/ktag.min.js?accountId=${knotchAccountId}` }),
    /* @__PURE__ */ jsx(B2BLayout, { router, env: environment, signInRedirectParam: "redirect", logo: img, menu: LAYOUT_MENU_ITEMS, submenu, transparent: header == null ? void 0 : header.transparent, disabled: header == null ? void 0 : header.disabled, footerColumns: FOOTER_COLUMNS, primaryCTALink: HEADER_CTAS.primary.url, primaryCTALabel: HEADER_CTAS.primary.label, secondaryCTALabel: HEADER_CTAS.secondary.label, secondaryCTAModal: /* @__PURE__ */ jsx(AgentLoginModal, { title: HEADER_CTAS.secondary.label }), sticky: true, children })
  ] });
};
export {
  ZillowForAgentsLayout as default
};
